import "./Events.html";
import "./Events.scss";

import "./EventsTable/EventsTableComponent";
import "./EventsTimeLine/EventsTimeLineComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EventsComponentController from "./EventsComponentController";

export class EventsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = EventsComponentController;
        this.templateUrl = "/App/Components/Site/Events/Events.html";
    }
}

module("mmManagePortal").component("irEvents", new EventsComponent());
